import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Grid, TextField, Card, CardContent, Button, Box, MenuItem } from '@material-ui/core';
// shared - core components
import Toast from '../../../../shared/components/Toast/Toast'
import LoaderContent from '../../../../shared/components/Loader/LoaderContent.jsx'
//SDK
import { ThinkificService } from '@sdk-point/talisis';

// @local
import { useStyles } from '../../../../assets/styles/jss/pages/microcredentials/useStyles';

const ThinkificServiceSDK = new ThinkificService(
  process.env.REACT_APP_ENV_V2,
  process.env.REACT_APP_X_API_KEY_V2
);

const BodyRequest = ({ readOnly = false, onClose, initialForm = null, onSave, onCancel, onSuccess, formData, onLoadingChange }) => {
  const classes = useStyles();
  const location = useLocation();
  const formFromState = location.state?.form;

  const [loading, setLoading] = React.useState(false);
  const [toastProps, setToastProps] = React.useState({ message: "", severity: "", open: false });
  const [errors, setErrors] = React.useState({});

  const [bundleOptions, setBundleOptions] = React.useState([]);
  const [microcredentialOptions, setMicrocredentialOptions] = React.useState([]);
  const [badgeOptions, setBadgeOptions] = React.useState([]);
  const [assignmentOptions, setAssignmentOptions] = React.useState([]);
  const [coursesOptions, setCoursesOptions] = React.useState([]);

  const [form, setForm] = React.useState({
    bundleId: "",
    microcredentialId: "",
    badgeId: "",
    assignmentId: "",
    courseId: "",
    badgeIdAutofill: true,
    badgeLocked: false
  });

  useEffect(() => {
    const initialForm = formData || formFromState;
    if (initialForm) {
      setForm({
        ...initialForm,
        badgeIdAutofill: true,
        badgeLocked: false
      });
    }
  }, [formData, formFromState]);

  const handleFinishedToast = () => setToastProps(prev => ({ ...prev, open: false }));

  const checkExistingCourseCreate = async (courseId) => {
    try {
      const response = await ThinkificServiceSDK.postCreateCatalogs({
        CatalogType: "rulesCheckByCourse",
        courseId
      });
      if (response.success && response.data) {
        return response.data.badge_id;
      }
    } catch (error) {
      console.error("Error verificando curso existente:", error);
    }
    return null;
  };

  const checkExistingCourseEdit = async (courseId, currentId) => {
    try {
      const response = await ThinkificServiceSDK.updateCatalogs({
        CatalogType: "rulesCheckByCourse",
        courseId,
        id: currentId 
      });

     
      if (response.success && response.data) {
        return response.data.badge_id;   
      }
    } catch (error) {
      console.error("Error verificando curso existente:", error);
    }

    return null;
  };



  const isEditMode = Boolean(form.id);

  const handleChange = async (event) => {
    const { name, value } = event.target;

    const idToSend = form.id; 

    // ---------------------------------------------------------
    //  VALIDACIÓN CUANDO CAMBIA EL COURSE 
    // ---------------------------------------------------------
    if (name === "courseId") {

       const existingBadge = await checkExistingCourseCreate(value);

      setForm(prev => ({
        ...prev,
        courseId: value,
        badgeId: "",
        badgeIdAutofill: true,
        badgeLocked: false
      }));

      if (existingBadge) {
        setForm(prev => ({
          ...prev,
          courseId: value,
          badgeId: existingBadge,
          badgeIdAutofill: false, 
          badgeLocked: true
        }));

        setToastProps({
          severity: "info",
          open: true,
          message: "Este curso ya tiene una insignia asignada"
        });

      } else {
        setForm(prev => ({
          ...prev,
          courseId: value,
          badgeIdAutofill: false,
          badgeLocked: false,
          badgeId: ""
        }));
      }

      return;
    }

    // ---------------------------------------------------------
    //  VALIDACIÓN CUANDO CAMBIA LA INSIGNIA 
    // ---------------------------------------------------------
    if (name === "badgeId") {

      
      const existingBadge = await checkExistingCourseEdit(form.courseId, form.id);

      
      if (existingBadge) {

        
        setForm(prev => ({
          ...prev,
          badgeId: existingBadge,
          badgeIdAutofill: false,
          badgeLocked: true
        }));

        setToastProps({
          severity: "info",
          open: true,
          message: "Este curso ya tiene una insignia asignada"
        });

        return; 
      }

     
      setForm(prev => ({
        ...prev,
        badgeId: value,
        badgeIdAutofill: false,
        badgeLocked: false
      }));

      return;
    }




    setForm(prev => ({ ...prev, [name]: value }));
  };


  const getCatalog = async (type, setter) => {
    try {
      const response = await ThinkificServiceSDK.getCatalogs({ CatalogType: type });
      if (response.success) {
        const mapped = response.data.map(item => ({ id: item.id, label: item.name }));
        setter(mapped);
      }
    } catch (error) {
      console.error(`Error cargando ${type}:`, error);
    }
  };


  useEffect(() => {
    let isMounted = true;
    async function loadData() {
      setLoading(true);
      try {
        await Promise.all([
          getCatalog("courses21", setCoursesOptions),
          getCatalog("assignment", setAssignmentOptions),
          getCatalog("bundle", setBundleOptions),
          getCatalog("microcredential", setMicrocredentialOptions),
          getCatalog("badge", setBadgeOptions),
        ]);

        if (formFromState && isMounted) {
          setForm({
            ...formFromState,
            badgeIdAutofill: true,
            badgeLocked: false
          });
        }
      } catch (error) {
        console.error("Error cargando catálogos:", error);
      } finally {
        if (isMounted) setLoading(false);
      }
    }

    loadData();
    return () => { isMounted = false; };
  }, [formFromState]);


  const validateForm = () => {
    let newErrors = {};

    const validateField = (value) => {
      const strValue = (value ?? "").toString().trim();
      if (strValue === "") {
        return `campo requerido`;
      }
      return null;
    };

    const fields = ["bundleId", "microcredentialId", "assignmentId", "courseId"];
    if (!form.badgeIdAutofill) fields.push("badgeId");

    fields.forEach(field => {
      const error = validateField(form[field]);
      if (error) newErrors[field] = error;
    });

    return newErrors;
  };


  const handleSubmit = async () => {
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setToastProps({ severity: "error", open: true, message: "Completa todos los campos obligatorios" });
      return;
    }

    setErrors({});
    setLoading(true);
    if (onLoadingChange) onLoadingChange(true);

    try {
      const cleanForm = { ...form };

      if (cleanForm.id) {
        const payloadUpdate = {
          CatalogType: "rules",
          id: cleanForm.id,
          bundle_id: cleanForm.bundleId,
          microcredential_id: cleanForm.microcredentialId,
          badge_id: cleanForm.badgeId,
          assignment_id: cleanForm.assignmentId,
          course_id: cleanForm.courseId,
        };

        await ThinkificServiceSDK.updateCatalogs(payloadUpdate);
        setToastProps({ severity: "success", open: true, message: "La acción se realizó correctamente" });

        setTimeout(() => { if (onSuccess) onSuccess(); }, 800);

      } else {
        const payloadCreate = {
          CatalogType: "rules",
          bundleId: cleanForm.bundleId,
          microcredentialId: cleanForm.microcredentialId,
          badgeId: cleanForm.badgeId,
          assignmentId: cleanForm.assignmentId,
          courseId: cleanForm.courseId,
        };

        await ThinkificServiceSDK.postCreateCatalogs(payloadCreate);
        setToastProps({ severity: "success", open: true, message: "La acción se realizó correctamente" });

        setTimeout(() => { if (onSuccess) onSuccess(); }, 800);
      }

    } catch (error) {
      console.error("Error al guardar registro", error);
      setToastProps({ severity: "error", open: true, message: "Ha ocurrido un error al guardar el registro" });
    } finally {
      setLoading(false);
      if (onLoadingChange) onLoadingChange(false);
    }
  };


  return (
    <div>
      <Grid container spacing={3}>
        <Grid container item xs={12}>
          <LoaderContent>
            <Card>
              <CardContent>
                <Grid container spacing={3}>
                  <Grid container item xs={12} spacing={2}>

                    {[
                      { name: "bundleId", label: "Bundle", options: bundleOptions },
                      { name: "microcredentialId", label: "Microcredencial", options: microcredentialOptions },
                      { name: "assignmentId", label: "Tipo asignación", options: assignmentOptions },
                      { name: "courseId", label: "Unidad", options: coursesOptions },
                    ].map(field => (
                      <Grid item xs={12} sm={6} key={field.name}>
                        <TextField
                          select
                          required
                          label={field.label}
                          name={field.name}
                          margin="dense"
                          variant="outlined"
                          fullWidth
                          value={form[field.name] || ""}
                          onChange={handleChange}
                          error={Boolean(errors[field.name])}
                          helperText={errors[field.name]}
                          disabled={readOnly}
                        >
                          {field.options.map(option => (
                            <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                    ))}

                    {/* INSIGNIA — ahora visible en modo editar */}
                    {(isEditMode || !form.badgeIdAutofill) && (
                      <Grid item xs={12} sm={6}>
                        <TextField
                          select
                          required
                          label="Insignia"
                          name="badgeId"
                          margin="dense"
                          variant="outlined"
                          fullWidth
                          value={form.badgeId || ""}
                          onChange={handleChange}
                          error={Boolean(errors.badgeId)}
                          helperText={errors.badgeId}
                          disabled={form.badgeLocked || readOnly}
                        >
                          {badgeOptions.map(option => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                    )}

                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </LoaderContent>
        </Grid>

        <Grid container item xs={12}>
          <Box display="flex" justifyContent="flex-end" width="100%" backgroundColor={"white"} marginRight={"32px"}>
            {!readOnly && (
              <>
                <Button
                  className={classes.cancelButton}
                  variant="contained"
                  onClick={onClose}
                  disabled={loading}
                >
                  Regresar
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {isEditMode ? "Actualizar" : "Guardar"}
                </Button>
              </>
            )}
          </Box>
        </Grid>
        <Toast {...toastProps} onFinished={handleFinishedToast} />
      </Grid>
    </div>
  );
};

export default BodyRequest;
